var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9297A2",
    d: "M18 12c0 .552.448 1 1 1h2c.552 0 1-.448 1-1s-.448-1-1-1h-2c-.552 0-1 .448-1 1zm-1.199 6.208l1.6 1.195c.441.33 1.067.24 1.398-.201l.001-.002c.331-.442.242-1.069-.2-1.4l-1.598-1.198c-.441-.332-1.068-.242-1.4.2l-.001.002-.003.004c-.33.443-.238 1.07.203 1.4zM19.8 4.8c-.331-.442-.958-.531-1.4-.2l-1.6 1.2c-.442.331-.531.958-.2 1.4.331.442.958.531 1.4.2l1.6-1.2c.442-.331.531-.958.2-1.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v3c0 .552.448 1 1 1s1-.448 1-1v-3h1l3.486 2.091c.473.284 1.087.13 1.371-.343.094-.155.143-.333.143-.514V7.766c0-.552-.448-1-1-1-.181 0-.36.05-.514.143L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCta);
export default __webpack_public_path__ + "static/media/cta.d4fcbe3003e8154a6d9fa7c4256fbfcb.svg";
export { ForwardRef as ReactComponent };